import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';

import { useSite } from '../../context/site';
import { PickList } from 'primereact/picklist';

function ParentSearchSelectChildren({ open, parentsChildren, onClose }) {
    const [filteredParents, setFilteredParents] = useState([]);
    const [selectedParent, setSelectedParent] = useState('');
    const [sourceChildren, setSourceChildren] = useState([]);
    const [targetChildren, setTargetChildren] = useState([]);

    const { SearchParents } = useSite();

    const onSearchParent = (data) => {
        SearchParents(
            { query: data.query, excludedParents: [...parentsChildren.map((pc) => pc.parent._id)] },
            (res) => {
                setFilteredParents(res.data.parents);
            }
        );
    };

    const onCancel = () => {
        onClose();
    };

    const onChange = (event) => {
        setSourceChildren(event.source);
        setTargetChildren(event.target);
    };

    const onSelect = (e) => {
        onClose({
            parent: {
                ...selectedParent,
                nameFull: selectedParent.nameFilter
            },
            children: [...targetChildren]
        });
    };

    const buttonDisabled = () => {
        if (!selectedParent?._id) {
            return true;
        }

        return false;
    };

    const FooterContent = (
        <div>
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={onCancel}
                className="p-button-text"
            />
            <Button
                label="Select"
                disabled={buttonDisabled()}
                icon="pi pi-check"
                onClick={onSelect}
            />
        </div>
    );

    const parentItemTemplate = (parent) => {
        return (
            <div className="flex align-items-center">
                <div>
                    {parent.nameFirst} {parent.nameLast}, {parent.city},{' '}
                    {parent.state.itemData.abbr}
                </div>
            </div>
        );
    };

    const sourceItemTemplate = (child) => {
        return (
            <div className="flex align-items-center">
                <div>
                    {child.nameFirst} {child.nameLast} (Age {child.age})
                </div>
            </div>
        );
    };

    const targetItemTemplate = (child) => {
        return (
            <div className="flex align-items-center">
                <div>
                    {child.nameFirst} {child.nameLast} (Age {child.age})
                </div>
            </div>
        );
    };

    return (
        <Dialog
            header="Search for a Parent"
            visible={open}
            onHide={onCancel}
            footer={FooterContent}
            className="w-6"
        >
            <div className="mt-2">
                <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <AutoComplete
                            field="nameFilter"
                            value={selectedParent}
                            suggestions={filteredParents}
                            completeMethod={onSearchParent}
                            onSelect={(e) => {
                                setSourceChildren(
                                    Array.isArray(e.value.children) ? [...e.value.children] : []
                                );
                            }}
                            onChange={(e) => {
                                setSelectedParent(e.value);
                            }}
                            itemTemplate={parentItemTemplate}
                        />
                    </div>
                </div>

                {!selectedParent?._id ? null : (
                    <div className="card flex flex-wrap gap-3 p-fluid">
                        <div className="flex-auto">
                            <label htmlFor="parentId" className="font-bold block mb-2">
                                Children
                            </label>

                            <PickList
                                source={sourceChildren}
                                target={targetChildren}
                                onChange={onChange}
                                sourceItemTemplate={sourceItemTemplate}
                                showSourceControls={false}
                                targetItemTemplate={targetItemTemplate}
                                showTargetControls={false}
                            />
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    );
}

export default ParentSearchSelectChildren;
